import { render, staticRenderFns } from "./LdapSynchronization.vue?vue&type=template&id=0882214a&scoped=true"
import script from "./LdapSynchronization.vue?vue&type=script&lang=js"
export * from "./LdapSynchronization.vue?vue&type=script&lang=js"
import style0 from "./LdapSynchronization.vue?vue&type=style&index=0&id=0882214a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882214a",
  null
  
)

export default component.exports